class Atlas {
  constructor() {
    this.groups = {
      main: [],
    };
  }

  init(groupName) {
    if (!this.groups[groupName]) {
      this.groups[groupName] = [];
    }

    return this;
  }

  add(fieldName, groupName = 'main') {
    this.init(groupName);

    this.groups[groupName].push(fieldName);
    return this;
  }

  forEach(cb = () => {}) {
    const groups = this.groups;

    const crawl = groupName => {
      groups[groupName].forEach(fieldName => {
        if (groups[fieldName]) {
          cb(fieldName, groupName);
          crawl(fieldName);
        } else {
          cb(fieldName, groupName);
        }
      });
    };

    crawl('main');
    return this;
  }
}

export default Atlas;
